'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var NanoDate = require('timestamp-nano');

var key = require('interface-datastore/key');

var crypto = require('libp2p-crypto');

var PeerId = require('peer-id');

var Digest = require('multiformats/hashes/digest');

var identity = require('multiformats/hashes/identity');

var errCode = require('err-code');

var base32 = require('multiformats/bases/base32');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

var concat = require('uint8arrays/concat');

var equals = require('uint8arrays/equals');

var cborg = require('cborg');

var Long = require('long');

var debug = require('debug');

var ipns = require('./pb/ipns.js');

var utils = require('./utils.js');

var errors = require('./errors.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var NanoDate__default = /*#__PURE__*/_interopDefaultLegacy(NanoDate);

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var Digest__namespace = /*#__PURE__*/_interopNamespace(Digest);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var cborg__namespace = /*#__PURE__*/_interopNamespace(cborg);

var Long__default = /*#__PURE__*/_interopDefaultLegacy(Long);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = Object.assign(debug__default['default']('jsipns'), {
  error: debug__default['default']('jsipns:error')
});
var ID_MULTIHASH_CODE = identity.identity.code;
var IPNS_PREFIX = fromString.fromString('/ipns/');
var namespace = '/ipns/';
var namespaceLength = namespace.length;

var create = function create(privateKey, value, seq, lifetime) {
  var expirationDate = new NanoDate__default['default'](Date.now() + Number(lifetime));
  var validityType = ipns.IpnsEntry.ValidityType.EOL;

  var _lifetime$toString$sp = lifetime.toString().split('.'),
      _lifetime$toString$sp2 = _slicedToArray(_lifetime$toString$sp, 2),
      ms = _lifetime$toString$sp2[0],
      ns = _lifetime$toString$sp2[1];

  var lifetimeNs = BigInt(ms) * BigInt(100000) + BigInt(ns || 0);
  return _create(privateKey, value, seq, validityType, expirationDate, lifetimeNs);
};

var createWithExpiration = function createWithExpiration(privateKey, value, seq, expiration) {
  var expirationDate = NanoDate__default['default'].fromString(expiration);
  var validityType = ipns.IpnsEntry.ValidityType.EOL;
  var ttlMs = expirationDate.toDate().getTime() - Date.now();
  var ttlNs = BigInt(ttlMs) * BigInt(100000) + BigInt(expirationDate.getNano());
  return _create(privateKey, value, seq, validityType, expirationDate, ttlNs);
};

var _create = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(privateKey, value, seq, validityType, expirationDate, ttl) {
    var isoValidity, signatureV1, data, sigData, signatureV2, entry;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            seq = BigInt(seq);
            isoValidity = fromString.fromString(expirationDate.toString());
            _context.next = 4;
            return sign(privateKey, value, validityType, isoValidity);

          case 4:
            signatureV1 = _context.sent;
            data = createCborData(value, isoValidity, validityType, seq, ttl);
            sigData = ipnsEntryDataForV2Sig(data);
            _context.next = 9;
            return privateKey.sign(sigData);

          case 9:
            signatureV2 = _context.sent;
            entry = {
              value: value,
              signature: signatureV1,
              validityType: validityType,
              validity: isoValidity,
              sequence: seq,
              ttl: ttl,
              signatureV2: signatureV2,
              data: data
            };
            log("ipns entry for ".concat(value, " created"));
            return _context.abrupt("return", entry);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function _create(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

var createCborData = function createCborData(value, validity, validityType, sequence, ttl) {
  var data = {
    Value: value,
    Validity: validity,
    ValidityType: validityType,
    Sequence: sequence,
    TTL: ttl
  };
  return cborg__namespace.encode(data);
};

var _validate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(publicKey, entry) {
    var value, validityType, validity, dataForSignature, signature, isValid, validityDate;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            value = entry.value, validityType = entry.validityType, validity = entry.validity;

            if (entry.signatureV2 && entry.data) {
              signature = entry.signatureV2;
              dataForSignature = ipnsEntryDataForV2Sig(entry.data);
              validateCborDataMatchesPbData(entry);
            } else {
              signature = entry.signature;
              dataForSignature = ipnsEntryDataForV1Sig(value, validityType, validity);
            }

            _context2.prev = 2;
            _context2.next = 5;
            return publicKey.verify(dataForSignature, signature);

          case 5:
            isValid = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            isValid = false;

          case 11:
            if (isValid) {
              _context2.next = 14;
              break;
            }

            log.error('record signature verification failed');
            throw errCode__default['default'](new Error('record signature verification failed'), errors.ERR_SIGNATURE_VERIFICATION);

          case 14:
            if (!(validityType === ipns.IpnsEntry.ValidityType.EOL)) {
              _context2.next = 28;
              break;
            }

            _context2.prev = 15;
            validityDate = utils.parseRFC3339(toString.toString(validity));
            _context2.next = 23;
            break;

          case 19:
            _context2.prev = 19;
            _context2.t1 = _context2["catch"](15);
            log.error('unrecognized validity format (not an rfc3339 format)');
            throw errCode__default['default'](new Error('unrecognized validity format (not an rfc3339 format)'), errors.ERR_UNRECOGNIZED_FORMAT);

          case 23:
            if (!(validityDate.getTime() < Date.now())) {
              _context2.next = 26;
              break;
            }

            log.error('record has expired');
            throw errCode__default['default'](new Error('record has expired'), errors.ERR_IPNS_EXPIRED_RECORD);

          case 26:
            _context2.next = 31;
            break;

          case 28:
            if (!validityType) {
              _context2.next = 31;
              break;
            }

            log.error('unrecognized validity type');
            throw errCode__default['default'](new Error('unrecognized validity type'), errors.ERR_UNRECOGNIZED_VALIDITY);

          case 31:
            log("ipns entry for ".concat(value, " is valid"));

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8], [15, 19]]);
  }));

  return function validate(_x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var validateCborDataMatchesPbData = function validateCborDataMatchesPbData(entry) {
  if (!entry.data) {
    throw errCode__default['default'](new Error('Record data is missing'), errors.ERR_INVALID_RECORD_DATA);
  }

  var data = cborg__namespace.decode(entry.data);

  if (Number.isInteger(data.Sequence)) {
    data.Sequence = BigInt(data.Sequence);
  }

  if (Number.isInteger(data.TTL)) {
    data.TTL = BigInt(data.TTL);
  }

  if (!equals.equals(data.Value, entry.value)) {
    throw errCode__default['default'](new Error('Field "value" did not match between protobuf and CBOR'), errors.ERR_SIGNATURE_VERIFICATION);
  }

  if (!equals.equals(data.Validity, entry.validity)) {
    throw errCode__default['default'](new Error('Field "validity" did not match between protobuf and CBOR'), errors.ERR_SIGNATURE_VERIFICATION);
  }

  if (data.ValidityType !== entry.validityType) {
    throw errCode__default['default'](new Error('Field "validityType" did not match between protobuf and CBOR'), errors.ERR_SIGNATURE_VERIFICATION);
  }

  if (data.Sequence !== entry.sequence) {
    throw errCode__default['default'](new Error('Field "sequence" did not match between protobuf and CBOR'), errors.ERR_SIGNATURE_VERIFICATION);
  }

  if (data.TTL !== entry.ttl) {
    throw errCode__default['default'](new Error('Field "ttl" did not match between protobuf and CBOR'), errors.ERR_SIGNATURE_VERIFICATION);
  }
};

var embedPublicKey = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(publicKey, entry) {
    var error, peerId, extractedPublicKey;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!publicKey || !publicKey.bytes || !entry)) {
              _context3.next = 4;
              break;
            }

            error = new Error('one or more of the provided parameters are not defined');
            log.error(error);
            throw errCode__default['default'](error, errors.ERR_UNDEFINED_PARAMETER);

          case 4:
            _context3.prev = 4;
            _context3.next = 7;
            return PeerId__default['default'].createFromPubKey(publicKey.bytes);

          case 7:
            peerId = _context3.sent;
            _context3.next = 13;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](4);
            throw errCode__default['default'](_context3.t0, errors.ERR_PEER_ID_FROM_PUBLIC_KEY);

          case 13:
            _context3.prev = 13;
            extractedPublicKey = extractPublicKeyFromId(peerId);
            _context3.next = 21;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t1 = _context3["catch"](13);
            log.error(_context3.t1);
            throw errCode__default['default'](_context3.t1, errors.ERR_PUBLIC_KEY_FROM_ID);

          case 21:
            if (!extractedPublicKey) {
              _context3.next = 23;
              break;
            }

            return _context3.abrupt("return", null);

          case 23:
            _context3.prev = 23;
            entry.pubKey = crypto__default['default'].keys.marshalPublicKey(publicKey);
            _context3.next = 31;
            break;

          case 27:
            _context3.prev = 27;
            _context3.t2 = _context3["catch"](23);
            log.error(_context3.t2);
            throw _context3.t2;

          case 31:
            return _context3.abrupt("return", entry);

          case 32:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 10], [13, 17], [23, 27]]);
  }));

  return function embedPublicKey(_x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var extractPublicKey = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerId, entry) {
    var error, pubKey, otherId;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!entry || !peerId)) {
              _context4.next = 4;
              break;
            }

            error = new Error('one or more of the provided parameters are not defined');
            log.error(error);
            throw errCode__default['default'](error, errors.ERR_UNDEFINED_PARAMETER);

          case 4:
            if (!entry.pubKey) {
              _context4.next = 20;
              break;
            }

            _context4.prev = 5;
            pubKey = crypto__default['default'].keys.unmarshalPublicKey(entry.pubKey);
            _context4.next = 13;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](5);
            log.error(_context4.t0);
            throw _context4.t0;

          case 13:
            _context4.next = 15;
            return PeerId__default['default'].createFromPubKey(entry.pubKey);

          case 15:
            otherId = _context4.sent;

            if (otherId.equals(peerId)) {
              _context4.next = 18;
              break;
            }

            throw errCode__default['default'](new Error('Embedded public key did not match PeerID'), errors.ERR_INVALID_EMBEDDED_KEY);

          case 18:
            _context4.next = 21;
            break;

          case 20:
            if (peerId.pubKey) {
              pubKey = peerId.pubKey;
            }

          case 21:
            if (!pubKey) {
              _context4.next = 23;
              break;
            }

            return _context4.abrupt("return", pubKey);

          case 23:
            throw errCode__default['default'](new Error('no public key is available'), errors.ERR_UNDEFINED_PARAMETER);

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[5, 9]]);
  }));

  return function extractPublicKey(_x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();

var rawStdEncoding = function rawStdEncoding(key) {
  return base32.base32upper.encode(key).slice(1);
};

var getLocalKey = function getLocalKey(key$1) {
  return new key.Key("/ipns/".concat(rawStdEncoding(key$1)));
};

var getIdKeys = function getIdKeys(pid) {
  var pkBuffer = fromString.fromString('/pk/');
  var ipnsBuffer = fromString.fromString('/ipns/');
  return {
    routingPubKey: new key.Key(concat.concat([pkBuffer, pid]), false),
    pkKey: new key.Key(rawStdEncoding(concat.concat([pkBuffer, pid]))),
    routingKey: new key.Key(concat.concat([ipnsBuffer, pid]), false),
    ipnsKey: new key.Key(rawStdEncoding(concat.concat([ipnsBuffer, pid])))
  };
};

var sign = function sign(privateKey, value, validityType, validity) {
  try {
    var dataForSignature = ipnsEntryDataForV1Sig(value, validityType, validity);
    return privateKey.sign(dataForSignature);
  } catch (error) {
    log.error('record signature creation failed');
    throw errCode__default['default'](new Error('record signature creation failed: ' + error.message), errors.ERR_SIGNATURE_CREATION);
  }
};

var getValidityType = function getValidityType(validityType) {
  if (validityType.toString() === '0') {
    return 'EOL';
  }

  var error = new Error("unrecognized validity type ".concat(validityType.toString()));
  log.error(error);
  throw errCode__default['default'](error, errors.ERR_UNRECOGNIZED_VALIDITY);
};

var ipnsEntryDataForV1Sig = function ipnsEntryDataForV1Sig(value, validityType, validity) {
  var validityTypeBuffer = fromString.fromString(getValidityType(validityType));
  return concat.concat([value, validity, validityTypeBuffer]);
};

var ipnsEntryDataForV2Sig = function ipnsEntryDataForV2Sig(data) {
  var entryData = fromString.fromString('ipns-signature:');
  return concat.concat([entryData, data]);
};

var extractPublicKeyFromId = function extractPublicKeyFromId(peerId) {
  var digest = Digest__namespace.decode(peerId.id);

  if (digest.code !== ID_MULTIHASH_CODE) {
    return null;
  }

  return crypto__default['default'].keys.unmarshalPublicKey(digest.digest);
};

var marshal = function marshal(obj) {
  return ipns.IpnsEntry.encode(_objectSpread(_objectSpread({}, obj), {}, {
    sequence: Long__default['default'].fromString(obj.sequence.toString()),
    ttl: obj.ttl == null ? undefined : Long__default['default'].fromString(obj.ttl.toString())
  })).finish();
};

var unmarshal = function unmarshal(buf) {
  var message = ipns.IpnsEntry.decode(buf);
  var object = ipns.IpnsEntry.toObject(message, {
    defaults: false,
    arrays: true,
    objects: false
  });
  return {
    value: object.value,
    signature: object.signature,
    validityType: object.validityType,
    validity: object.validity,
    sequence: Object.hasOwnProperty.call(object, 'sequence') ? BigInt("".concat(object.sequence)) : 0,
    pubKey: object.pubKey,
    ttl: Object.hasOwnProperty.call(object, 'ttl') ? BigInt("".concat(object.ttl)) : undefined,
    signatureV2: object.signatureV2,
    data: object.data
  };
};

var validator = {
  validate: function () {
    var _validate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(marshalledData, key) {
      var receivedEntry, bufferId, peerId, pubKey;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              receivedEntry = unmarshal(marshalledData);
              bufferId = key.slice(IPNS_PREFIX.length);
              peerId = PeerId__default['default'].createFromBytes(bufferId);
              _context5.next = 5;
              return extractPublicKey(peerId, receivedEntry);

            case 5:
              pubKey = _context5.sent;
              _context5.next = 8;
              return _validate(pubKey, receivedEntry);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function validate(_x13, _x14) {
      return _validate2.apply(this, arguments);
    }

    return validate;
  }(),
  select: function select(dataA, dataB) {
    var entryA = unmarshal(dataA);
    var entryB = unmarshal(dataB);

    if (entryA.signatureV2 && !entryB.signatureV2) {
      return 0;
    } else if (entryB.signatureV2 && !entryA.signatureV2) {
      return 1;
    }

    if (entryA.sequence > entryB.sequence) {
      return 0;
    } else if (entryA.sequence < entryB.sequence) {
      return 1;
    }

    var entryAValidityDate = utils.parseRFC3339(toString.toString(entryA.validity));
    var entryBValidityDate = utils.parseRFC3339(toString.toString(entryB.validity));
    return entryBValidityDate.getTime() > entryAValidityDate.getTime() ? 1 : 0;
  }
};
exports.create = create;
exports.createWithExpiration = createWithExpiration;
exports.embedPublicKey = embedPublicKey;
exports.extractPublicKey = extractPublicKey;
exports.getIdKeys = getIdKeys;
exports.getLocalKey = getLocalKey;
exports.marshal = marshal;
exports.namespace = namespace;
exports.namespaceLength = namespaceLength;
exports.unmarshal = unmarshal;
exports.validate = _validate;
exports.validator = validator;